jQuery(document).ready(function($) { 
    $('#quick-shop-modal').on('hidden.bs.modal', function () {
        $('.zoomContainer').css('z-index', '1');
        $('#top').removeClass('z-idx');
    })

    $('#quick-shop-modal').on( 'shown.bs.modal', function () {
        $('#top').addClass('z-idx');
        $('.modal-dialog').addClass("animated");
        imagesLoaded( '#quick-shop-modal', function() {       
            updateScrollThumbsQS();       
            $("#gallery_main_qs .qs-vertical-slider").owlCarousel({
            dots: true,
            nav: false,
            
            autoplaySpeed : 200,
            responsive: {
                360: {
                items: 1
                },
                768: {
                items: 1
                },
                979: {
                items: 1
                },
                1199: {
                items: 1
                }
            },
            navText: ['<i class="fa fa-angle-left" title="Previous" data-toggle="tooltip" data-placement="top"></i>', '<i class="fa fa-angle-right" title="Next" data-toggle="tooltip" data-placement="top"></i>']
            });
            var delayLoadingQS = '';       
            delayLoadingQS = setInterval(function(){                     
            quickShopModalBackground.hide();
            $('.zoomContainer').css('z-index', '2000');
            $('#quick-shop-modal .modal-body').resize();           
            clearInterval( delayLoadingQS );            
            }, 500);
        });      
    });
    
    var quickShopModal = $('#quick-shop-modal');
    var quickShopContainer = $('#quick-shop-container');
    var quickShopImage = $('#quick-shop-image');
    var quickShopTitle = $('#quick-shop-title-container');
    var quickShopRating = $('.rating-star');
    var quickShopDescription = $('#quick-shop-description');
    var quickShopVariantsContainer = $('#quick-shop-variants-container');
    var quickShopPriceContainer = $('#quick-shop-price-container');
    var quickShopAddButton = $('#quick-shop-add');
    var quickShopAddToCartButton = $('#quick-shop-add');
    var quickShopTags = $('#quick-shop-tags');
    var quickShopProductActions = $('#quick-shop-product-actions');
    var quickShopModalBackground = $('#quick-shop-modal .quick-shop-modal-bg');
    
    $('body').on(clickEv, '.quick_shop:not(.unavailable)', function(event){
    var quickShopImage = $('#quick-shop-image');     
    var $this = $(this);
    var product_json = $this.find('.product-json').html();
    var selectedProduct = JSON.parse(product_json);
    var quickView = $this.find('.product-quickview').html();
    var quickViewText=JSON.parse(quickView);
    var selectedProductID = selectedProduct.id;
    var product_tags=  selectedProduct.tags;
    
    $('.pricing-tier-quick-view').html($this.find('.pricing_qv_tier_view').html());
    // Update add button
    quickShopAddButton.data('product-id', selectedProductID);
    
    // Update image
    quickShopImage.empty();
    //quickShopImage.html('<div id="featuted-image" class="main-image featured"><img class="img-zoom img-responsive image-fly" src="'+ Shopify.resizeImage(selectedProduct.featured_image, "large")+'" data-zoom-image="'+ selectedProduct.featured_image +'" alt="" /></div>');
    quickShopImage.html('<div id="featuted-image" class="main-image featured"><img class="img-zoom img-responsive image-fly" src="'+ selectedProduct.featured_image +'" data-zoom-image="'+ selectedProduct.featured_image +'" alt="" /></div>');	
    quickShopImage.append('<div id="gallery_main_qs" class="product-image-thumb scroll scroll-mini"><div class="qs-vertical-slider owl-carousel owl-theme"></div></div>');
    quickShopImage.append('<div class="vertical-slider"></div>');
    var qs_images = selectedProduct.images;
    $.each(qs_images, function(index, value) {
        if(index)
        quickShopImage.find('.qs-vertical-slider').append('<a class="image-thumb" href="'+value+'" alt="" data-image="'+ Shopify.resizeImage(value, 'large') +'" data-zoom-image="'+ Shopify.resizeImage(value, 'original') +'"><img src="'+ Shopify.resizeImage(value, "large") +'" alt="" /></a>');
        else
        quickShopImage.find('.qs-vertical-slider').append('<a class="image-thumb active" href="'+value+'" alt="" data-image="'+ Shopify.resizeImage(value, 'large') +'" data-zoom-image="'+ Shopify.resizeImage(value, 'original') +'"><img src="'+ Shopify.resizeImage(value, "large") +'" alt="" /></a>');
    });  
    
    
    // Update title
    quickShopTitle.html('<h3 id="quick-shop-title"><a href="/products/' + selectedProduct.handle + '">' + selectedProduct.title + '</a></h3>');
        
    // Update Rating Review
    quickShopRating.html('<span class="shopify-product-reviews-badge" data-id="'+ selectedProduct.id +'"></span>');
    
    // Update description
    
    //if(quickViewText!="")
    //  quickShopDescription.html(quickViewText);
    // else
        quickShopDescription.html(selectedProduct.description.substring(0,140)+"...");
    
        
    // Generate variants
    var productVariants = selectedProduct.variants;
    var productVariantsCount = productVariants.length;
        
    quickShopPriceContainer.html('');
    quickShopVariantsContainer.html('');
    quickShopAddToCartButton.removeAttr('disabled').fadeTo(200,1);
        
    if (productVariantsCount > 1) {          
        // Reveal variants container
        quickShopVariantsContainer.show();
        
        // Build variants element
        var quickShopVariantElement = $('<select>',{ 'id': ('#quick-shop-variants-' + selectedProductID) , 'name': 'id'});
        var quickShopVariantOptions = '';
        
        for (var i=0; i < productVariantsCount; i++) {
        quickShopVariantOptions += '<option value="'+ productVariants[i].id +'">'+ productVariants[i].title +'</option>'
        };
        
        // Add variants element to page
        quickShopVariantElement.append(quickShopVariantOptions);
        quickShopVariantsContainer.append(quickShopVariantElement);
        
        // Bind variants to OptionSelect JS
        new Shopify.OptionSelectors(('#quick-shop-variants-' + selectedProductID), { product: selectedProduct, onVariantSelected: selectOptionCallback });
        
        // Add label if only one product option and it isn't 'Title'.
        if (selectedProduct.options.length == 1 && selectedProduct.options[0] != 'Title' ){
        $('#quick-shop-product-actions .selector-wrapper:eq(0)').prepend('<label>'+ selectedProduct.options[0] +'</label>');
        }
        
        // Auto-select first available variant on page load.
        var found_one_in_stock = false;
        for (var i=0; i < selectedProduct.variants.length; i++) {      
        var variant = selectedProduct.variants[i];
        if(variant.available && found_one_in_stock == false) {      
            found_one_in_stock = true;
            for (var j=0; j < variant.options.length; j++){      
            $('.single-option-selector:eq('+ j +')').val(variant.options[j]).trigger('change');  
            }
        }
        }
        
        
        
    } else { // If product only has a single variant    
        // Hide unnecessary variants container
        quickShopVariantsContainer.hide(); 
        
        // Build variants element
        var quickShopVariantElement = $('<select>',{ 'id': ('#quick-shop-variants-' + selectedProductID) , 'name': 'id'});
        var quickShopVariantOptions = '';
        
        for (var i=0; i < productVariantsCount; i++) {
        quickShopVariantOptions += '<option value="'+ productVariants[i].id +'">'+ productVariants[i].title +'</option>'
        };
        
        // Add variants element to page
        quickShopVariantElement.append(quickShopVariantOptions);
        quickShopVariantsContainer.append(quickShopVariantElement);  
        
        // Add tags
        quickShopTags.html('Translation missing: en.products.general.tag'+ selectedProduct.tags);
        
        // Update the add button to include correct variant id
        quickShopAddToCartButton.data('variant-id', productVariants[0].id);
        
        // Determine if product is on sale
        quick_product_price = productVariants[0].price;
        var is_product_marketing =0;
        var is_product_proseries = 0;
        $.each(product_tags, function(index, value) {
            if(value=="Marketing Materials")
            {
            is_product_marketing = "1";
            }
            
            if(value=="Pro Series")
            {
            is_product_proseries = "1";
            }
        });   
    
        if($('#is_customer_special').val()=="1")
        {
        if(is_product_marketing=="1")
        {
            quick_product_price = "0.00";
        }
        
        if(is_product_proseries=="1")
        {
            quick_product_price = quick_product_price * 0.80;
        }
        } 
        
        if ( productVariants[0].compare_at_price > 0 && productVariants[0].compare_at_price > productVariants[0].price ) {
        quickShopPriceContainer.html('<del class="price_compare">'+ Shopify.formatMoney(productVariants[0].compare_at_price, money_format_update) + '</del>' + '<span class="price_sale">'+ Shopify.formatMoney(quick_product_price, money_format_update) +'</span>');
        } else {
        quickShopPriceContainer.html('<span class="price">'+ Shopify.formatMoney(quick_product_price, money_format_update) + '</span>' );
        }  
    } // END of (productVariantsCount > 1)
        
    
        
    });
        
    /* selectOptionCallback
    ===================================== */
    var selectOptionCallback = function(variant, selector) {      
    // selected a valid and in stock variant
    if (variant && ((variant.inventory_quantity > 0 && variant.inventory_management == 'shopify') || variant.inventory_management == null ) ) {                  
        quickShopAddToCartButton.data('variant-id', variant.id);
        quickShopAddToCartButton.removeAttr('disabled').fadeTo(200,1);        
        // determine if variant is on sale
        
        
        quick_product_price = variant.price;
        var is_product_marketing =0;
        var is_product_proseries = 0;
        product_tags=selector.product.tags;
        $.each(product_tags, function(index, value) {
            if(value=="Marketing Materials")
            {
            is_product_marketing = "1";
            }
            
            if(value=="Pro Series")
            {
            is_product_proseries = "1";
            }
        });   
    
        if($('#is_customer_special').val()=="1")
        {
        if(is_product_marketing=="1")
        {
            quick_product_price = "0.00";
        }
        
        if(is_product_proseries=="1")
        {
            quick_product_price = quick_product_price * 0.80;
        }
        } 
        
        if ( variant.compare_at_price > 0 && variant.compare_at_price > variant.price ) {
        quickShopPriceContainer.html('<del class="price_compare">'+ Shopify.formatMoney(variant.compare_at_price, money_format_update) + '</del>' + '<span class="price_sale">'+ Shopify.formatMoney(quick_product_price, money_format_update) +'</span>');
        } else {
        quickShopPriceContainer.html('<span class="price test">'+ Shopify.formatMoney(quick_product_price, money_format_update) + '</span>' );
        };       
        // selected an invalid or out of stock variant 
    } else {
    // variant doesn't exist
        quickShopAddToCartButton.attr('disabled', 'disabled').fadeTo(200,0.5);
        var message = variant ? "Sold Out" : "Unavailable";    
        quickShopPriceContainer.html('<span class="unavailable">' + message + '</span>');         
    }
    //swatch
    var form = jQuery('.quick-shop form.variants');
    for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
        if (radioButton.size()) {
        radioButton.get(0).checked = true;
        }
    }
    
    //change image
    if (variant && variant.featured_image) {
        var newImage = variant.featured_image; // New image object.
        var mainImageDomEl = jQuery('.main-image img')[0]; // DOM element of main image we need to swap.
        Shopify.Image.switchImage(newImage, mainImageDomEl, switchImage); 
    }
    
    
    }          
});